/** @jsxImportSource @emotion/react */
import React from 'react'

import ModulesRows from './ModulesRows'
import ProfilesTableHeader from './ProfilesTableHeader'
import { css } from '@emotion/react'

const PermissionsTable = () => {
  const style = css`
    min-width: 70rem;
  `
  return (
    <div css={style}>
      <ProfilesTableHeader />
      <ModulesRows />
    </div>
  )
}

export default PermissionsTable
